// @flow
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { withRouter } from 'react-router';
import navigationStructure from '../NavigationStructure.js';
import { Api } from '../Api.js';
//import { FAQ } from './FAQ.js';

import helpers from '../util/helpers';

import "../css/Menu.css";

type Props = {
  linkClicked: () => void
}

class Menu extends Component<Props> {

  linkClicked(linkClickedTo) {
    helpers.eventLog("nav:menu button pressed - Menu.linkClicked() - " + linkClickedTo);
    this.props.linkClicked(); // attach to onClick handlers of Links in Menu. Call Menu's parent (MenuButton) linkClicked via function sent via JSX props linkClicked={...}
  }

  faqClicked() {
    alert('open faq');
  }

  onClose(e: any) {
    //e.stopPropagation();
    e.preventDefault();
    //1 -- eh (not updating menuopen so has side-effects)
    //document.getElementsByClassName("menu")[0].style.display = 'none' // not quite -- we want to trigger toggleMenu
    //2 -- better, but not taking advantage of React
    //document.getElementsByClassName("menu-button-span")[0].click(); // toggleMenu
    //3 -- correct
    this.linkClicked('menu.close top');
    return false;
  }

  logoutClicked() {
    helpers.eventLog("nav:menu button pressed - Menu.logoutClicked()");
    document.getElementsByTagName("body")[0].style.overflow = "visible";
    Api.logout();
    this.props.history.push('/');
    this.props.appState.logOut();
  }

  participantHasResultsInGroup(group) {
    const group_name = this.props.intl.messages[`chemicals.${group}.data`];
    if(this.props.appState.groups !== undefined && this.props.appState.groups[group_name] !== undefined) {
      return this.props.appState.groups[group_name].filter((d) => d.mine === true).length > 0;
    }
    else
      return false;
  }

  render() {
    let currentPage = this.props.location.pathname;

    let pageKeys = Object.keys(navigationStructure);
    let itemsByHeader = {}
    for (let i = 0; i < pageKeys.length; i++) {
      let pageKey = pageKeys[i]
      let thisPage = navigationStructure[pageKey]

      let showInMenu = true;
      // some pages have a flag to not show in the menu
      if (thisPage.hideinmenu) {showInMenu = false;}
      // some of the beginning pages don't have a menu, and won't be in the menu
      if (!thisPage.menu) {showInMenu = false;}
      // don't show in menu if the participant doesn't have results
      if (thisPage.group) {
        if (!this.participantHasResultsInGroup(thisPage.group)) {
          showInMenu = false;
        }
      }
      // don't show the poe in the menu unless the study group is poe
      if (thisPage.id == "page.graphreading" && !this.props.appState.showPOE) {
        showInMenu = false;
      }

      if (showInMenu) {
        let header = thisPage.menuSection || "";
        if (!itemsByHeader[header]) {itemsByHeader[header] = []}
        thisPage.key = pageKey
        itemsByHeader[header].push(thisPage)
      }
    }

    let items = []
    let headers = Object.keys(itemsByHeader)
    for (let h = 0; h < headers.length; h++) {
      let header = headers[h]
      let noHeader = "";
      if (header) {
        let headerObject = (
          <li key={"header"+h}  className="menu-section-header">
            <FormattedMessage id={header}/>
          </li>
        )
        items.push(headerObject)
      } else if (header == "") {
        items.push(<div className="menu-section-separator" key={"section-separator"+h}></div>)
        noHeader = "no-header"
      }


      for (let i = 0; i < itemsByHeader[header].length; i++) {
        let page = itemsByHeader[header][i]
        let myPage = ""
        if (page.key == currentPage) {myPage = " current-page"}
        let menuItem = (
          <li key={page.key}>
            <Link to={page.key} onClick={this.linkClicked.bind(this, page.key  /*linkClickedTo*/)} className={'menu-item ' + noHeader + myPage} >
              <FormattedHTMLMessage id={page.id + ".title"} />
            </Link>
          </li>
        )
        items.push(menuItem)
      }
    }


    return (
      <div className='menu'>
        <a href='#' className="button right" onClick={this.onClose.bind(this)}><FormattedMessage id='close' defaultMessage='Cerrar' /></a>
        <h1 className="menu-title">
          <FormattedMessage id='menu' defaultMessage='Menú' />
        </h1>
        <ul>
          {items}
          <li>
            <div className='menu-item lowpriority no-header' onClick={this.logoutClicked.bind(this)}>
              <FormattedMessage id='menu.logout'  />
            </div>
          </li>
          <li>
          </li>
        </ul>
      </div>
    );
  }
}

export default withRouter(injectIntl(Menu));



// WEBPACK FOOTER //
// ./src/components/Menu.js